<template>
  <div id="paper-root" v-if="paperInfo">
    <a-layout theme="light">
      <a-layout-header>
        <a-row id="paper-header">
          <a-col :span="12">
            <span @click="paperDescVisible = true">
              <a-icon v-if="paperInfo.paperDesc" type="question-circle" />
              <span>{{ paperInfo.paperName }}</span>
            </span>
          </a-col>
          <a-col :span="12">
            <div style="text-align:right;">
              <a-button v-if="edit" type="danger" size="large" @click="savePaper">保存试卷</a-button>
            </div>
          </a-col>
        </a-row>
      </a-layout-header>
      <a-layout>
        <a-layout-sider :style="{ overflowY: 'auto' }">
          <a-card class="question-index">
            <a-row>
              <div v-for="(q, i) in paperQuestion" :key="i">
                <!-- 大题索引 -->
                <a-col v-if="q.questionSection" @click="jumpQuestion(i)" class="question-section" :span="24">{{ q.questionSection }}</a-col>
                <!-- 固定题索引 -->
                <a-col v-if="q.itemType==1" :span="6">
                  <a-tag color="purple" @click="jumpQuestion(i)">{{ q.questionIndex }}</a-tag>
                </a-col>
                <!-- 随机抽题索引 -->
                <template v-if="q.itemType==2">
                  <!-- <a-col :span="6" v-for="(rq,ri) in q.randomCountSum" :key="ri">
                    <a-tag @click="jumpQuestion(i)">{{ q.questionIndex+ri }}</a-tag>
                  </a-col> -->
                  <a-col :span="12">
                    <a-tag color="purple" @click="jumpQuestion(i)">{{q.questionIndex}} ~ {{q.questionIndex + q.randomCountSum - 1}}</a-tag>
                  </a-col>
                </template>
                <!-- 知识点抽题索引 -->
                <template v-if="q.itemType==3">
                  <a-col :span="12">
                    <a-tag color="purple" @click="jumpQuestion(i)">{{q.questionIndex}} ~ {{q.questionIndex + q.randomCountSum - 1}}</a-tag>
                  </a-col>
                </template>
              </div>
            </a-row>
          </a-card>
        </a-layout-sider>
        <a-layout-content
          :style="{ minHeight: '80vh', height: 'calc(100vh - 64px', overflow: 'auto' }"
        >
          <a-card class="paper-content" :bordered="false">
            <div v-for="(q, qi) in paperQuestion" :key="qi">
              <!-- 大标题 -->
              <div class="question-section" v-if="q.questionSection">
                <a-input style="width:calc(100% - 80px)" size="large" v-model="q.questionSection" placeholder="请输入大标题"></a-input>
                <a-divider type="vertical"></a-divider>
                <a-button shape="circle" type="danger" icon="delete" @click="delQuestionSection(qi)"/>
              </div>
              <!-- 题目内容 -->
              <a-card class="question-card" :id="'q-' + qi">
                <!-- 知识点抽题 -->
                <div v-if="q.itemType==3">
                  <div class="question-stem">
                    <h2>知识点抽题  （共{{parseInt(q.randomCount[0]) + parseInt(q.randomCount[1]) + parseInt(q.randomCount[2])}}道）</h2>
                    <j-category-select v-model="q.randomSource" pcode="A07" multiple disabled placeholder="请选择知识点" />
                    <br><br>
                    <a-tag color="green">易：{{q.randomCount[0]}}道</a-tag>
                    <a-tag color="orange">中：{{q.randomCount[1]}}道</a-tag>
                    <a-tag color="red">难：{{q.randomCount[2]}}道</a-tag>
                  </div>
                </div>
                <!-- 随机抽题 -->
                <div v-if="q.itemType==2">
                  <div class="question-stem">
                    <h2>
                      <span>抽题 ({{q.randomSource.length}} 抽 {{q.randomCountSum}})</span>
                      <span>（备注：下方仅随机显示 {{q.randomCountSum}} 道）</span>
                    </h2>
                    <a-divider type="vertical"></a-divider>
                    <div v-for="(rq, ri) in q.randomCountSum" :key="ri">
                      <a-divider></a-divider>
                      <QuestionCard :questionIndex="q.questionIndex+ri" :questionInfo="q.randomSource[ri]"/>
                    </div>
                  </div>
                  <a-divider/>
                </div>
                <!-- 固定题目 -->
                <div v-if="q.itemType==1">
                  <QuestionCard :questionIndex="q.questionIndex" :questionInfo="q"/>
                </div>
                <a-divider />
                <a-row :gutter="40">
                  <!-- <a-col :span="6">
                    <p v-if="q.itemType==1">
                      <span>答案:</span>
                      <span>{{ answer2Text(paperQuestion[qi]) }}</span>
                    </p>
                  </a-col> -->
                  <a-col :span="6">
                    <div v-if="q.itemType==1">
                      <a-tag>题目ID：{{ q.id }}</a-tag>
                      <a-tag color="orange">参考分: {{ q.defaultScore }}</a-tag>
                    </div>
                    
                  </a-col>
                  <!-- 题目操作按钮 -->
                  <a-col :span="12">
                    <div class="item-operation" v-if="edit">
                        <a-input v-if="q.itemType==1 || q.itemType==2" addonBefore="分值" style="width:120px" type="number" min="0" v-model="q.paperQuestionScore"></a-input>
                        <a-divider v-if="q.itemType==1 || q.itemType==2" type="vertical"></a-divider>
                        <a-button v-if="q.itemType==1" shape="circle" type="primary" icon="edit" @click="editQuestion(q)"/>
                        <a-divider v-if="q.itemType==1" type="vertical"></a-divider>
                        <a-button shape="circle" type="primary" icon="up" @click="moveUpQuestion(qi)" :disabled="qi == 0" />
                        <a-divider type="vertical"></a-divider>
                        <a-button  shape="circle" type="primary" icon="down" @click="moveDownQuestion(qi)"  :disabled="qi == paperQuestion.length - 1" />
                        <a-divider type="vertical"></a-divider>
                        <a-dropdown>
                          <a-button shape="circle" icon="plus" @click="addQuestion(qi)" type="primary"></a-button>
                          <a-menu slot="overlay">
                            <a-menu-item>
                              <a-button type="primary" @click="addQuestionSection(qi)">添加大题标题</a-button>
                            </a-menu-item>
                            <a-menu-item>
                              <a-button type="primary" @click="addQuestion(qi)">添加固定题目</a-button>
                            </a-menu-item>
                            <a-menu-item>
                              <a-button type="primary" @click="addQuestionRandom(qi)">添加随机题目</a-button>
                            </a-menu-item>
                            <a-menu-item>
                              <a-button type="primary" @click="addQuestionFromKnowleage(qi)">从知识点抽题</a-button>
                            </a-menu-item>
                          </a-menu>
                        </a-dropdown>
                        <a-divider type="vertical"></a-divider>
                        <a-popconfirm title="确定从试卷中移除该题目吗?" @confirm="() => delQuestion(qi)">
                            <a-button shape="circle" type="danger" icon="delete"/>
                        </a-popconfirm>
                    </div>
                  </a-col>
                </a-row>
              </a-card>
            </div>
            <div v-if="!paperQuestion || paperQuestion.length==0">
              <a-dropdown v-if="edit">
                <a-button icon="plus" @click="addQuestion(qi)" type="primary" size="large" style="display:block;margin:50px auto;">添加题目</a-button>
                <a-menu slot="overlay">
                  <!-- <a-menu-item>
                    <a-button type="primary" @click="addQuestionSection(qi)">添加大题标题</a-button>
                  </a-menu-item> -->
                  <a-menu-item>
                    <a-button type="primary" @click="addQuestion(qi)">添加固定题目</a-button>
                  </a-menu-item>
                  <a-menu-item>
                    <a-button type="primary" @click="addQuestionRandom(qi)">添加随机题目</a-button>
                  </a-menu-item>
                  <a-menu-item>
                    <a-button type="primary" @click="addQuestionFromKnowleage(qi)">从知识点抽题</a-button>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </a-card>
        </a-layout-content>
      </a-layout>
    </a-layout>
    <a-modal
      :width="'800px'"
      :visible="paperDescVisible"
      :title="$t('exam.paperDesc')"
      :destroyOnClose="true"
      :footer="null"
      @cancel="paperDescVisible = false"
    >
      <div v-html="paperInfo.paperDesc"></div>
    </a-modal>
    <teaching-question-modal ref="questionModalForm" @ok="editQuestionOk" />
    <TSelectQuestionModal
      ref="selectQuestionModal" 
      :modal-width="500"
      :multi="true"
      @ok="handleSelectQuestionOK"/>
    <SelectKnowleageQuestionModal ref="selectKnowleageQuestionModal" @ok="handleSelectQuestion"/>
    <a-modal title="确认添加抽题" 
      :visible="current.currentItemType==2 && current.currentSelectQuestions!=null" 
      @ok="ensureAddQuestionRandom"
      @cancel="current.currentItemType = 0; current.currentSelectQuestions=null"
      >
      <div v-if="current.currentSelectQuestions">
        <h2>当前已选择题目：<span style="color:red;">{{current.currentSelectQuestions.length}}</span> 道</h2>
        <h2>从当前题目中随机抽取：<a-input-number :min="1" v-model="current.randomCount" style="width:100px;"/> 道</h2>
        <h2>统一分数：<a-input :min="1" v-model="current.currentRandomScore" style="width:150px;"></a-input></h2>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { getAction, putAction } from '@/api/manage'
import { examMixins } from '@/utils/examMixins'
import TeachingQuestionModal from './components/testPaper/TeachingQuestionModal'
import TSelectQuestionModal from './components/testPaper/selector/TSelectQuestionModal'
import QuestionCard from './components/testPaper/QuestionCard'
import SelectKnowleageQuestionModal from './components/testPaper/SelectKnowleageQuestionModal'
import JCategorySelect from '@/components/jeecg/JCategorySelect'

export default {
  name: 'PaperComposing',
  mixins: [examMixins],
  components:{
    TeachingQuestionModal,
    TSelectQuestionModal,
    QuestionCard,
    SelectKnowleageQuestionModal,
    JCategorySelect
  },
  data() {
    return {
      edit: false,
      paperId: null,
      paperInfo: null,
      paperQuestion: [], //已经过转换的题目信息
    //   questionSections: {}, //题目分类信息
      paperDescVisible: false, //试卷介绍是否可见
      editorUrl: '',
      current:{
        currentIndex: 0, //当前正在操作的题目序号
        currentItemType: 0, //当前添加的类型
        currentSelectQuestions: null, //当前已选择的题目
        randomCount: 1, //随机抽几道
        currentRandomScore: 0, //统一分数
      }
    }
  },
  created() {
    this.paperId = this.$route.query.id
    this.edit = this.$route.query.edit == 'true'
    this.getPaperInfo(this.paperId)
  },
  mounted() {
  },
  methods: {
    savePaper(){
      let paperItems = []
      console.log(this.paperQuestion);
      for(let i=0; i<this.paperQuestion.length;i++){
        let q = this.paperQuestion[i]
        if(q.itemType == 1){
          paperItems.push({
            itemType: q.itemType,
            questionSection: q.questionSection,
            questionId: q.questionId,
            paperQuestionScore: q.paperQuestionScore,
            questionType: q.questionType,
            orderNum: q.orderNum
          })
        }else if(q.itemType == 2){
          let randomSourceIds = q.randomSource.map(x=>{return x.id}).join(',')
          paperItems.push({
            itemType: q.itemType,
            questionSection: q.questionSection,
            paperQuestionScore: q.paperQuestionScore,
            orderNum: q.orderNum,
            randomCount: q.randomCount,
            randomSource: randomSourceIds
          })
        }else if(q.itemType == 3){
          paperItems.push({
            itemType: q.itemType,
            questionSection: q.questionSection,
            orderNum: q.orderNum,
            randomCount: q.randomCount,
            randomSource: q.randomSource
          })
        }

      }
      let reqBody = {
        paperId: this.paperId,
        paperItems: paperItems
      }
      putAction("/teaching/teachingPaper/savePaperItems", reqBody).then(res=>{
        if(res.success){
          this.$message.success("保存成功")
        }else{
          this.$message.error(res.message)
        }
      })
    },
    //获取试卷信息
    getPaperInfo(id) {
      this.paperQuestion = []
      return getAction(`/teaching/teachingPaper/getPaperPreview?paperId=${id}`).then((res) => {
        if (res.success && res.result != null) {
          this.paperInfo = res.result.paper
          for (let qi in res.result.question) {
            this.parseQuestion(res.result.question[qi])
          }
          this.calcOrderNum()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //解析题目(题目，索引)
    parseQuestion(q, index){
      console.log('parse question:', q, index)
      //兼容旧数据，生成大题标题
      // if (q.questionSection && q.itemType != 0) {
      //     this.paperQuestion.push({
      //         itemType: 0,
      //         questionSection: q.questionSection
      //     })
      // }
      //随机抽题类型，将ID列表转为对象列表
      if(q.itemType == 2 && typeof q.randomSource == 'string'){
        q.randomSource = q.randomSource.split(',').map(x=>({id: x}))
        console.log("randomSour", q.randomSource);
      }
      //抽题类型，将ID列表转为对象列表
      if(q.itemType == 3 && typeof q.randomCount == 'string'){
        q.randomCount = JSON.parse(q.randomCount)
      }
      //如果指定了索引，则在该索引之后插入题目
      if(index === undefined){
        this.paperQuestion.push(q)
      }else{
        this.paperQuestion.splice(index, 0, q)
      }
    },
    //检测是否存在重复题目
    checkDuplicateQuestion(){},

    //上移题目
    moveUpQuestion(index) {
      let t = this.paperQuestion[index - 1]
      Vue.set(this.paperQuestion, index - 1, this.paperQuestion[index])
      Vue.set(this.paperQuestion, index, t)
      this.calcOrderNum()
    },
    //下移题目
    moveDownQuestion(index) {
      let t = this.paperQuestion[index + 1]
      Vue.set(this.paperQuestion, index + 1, this.paperQuestion[index])
      Vue.set(this.paperQuestion, index, t)
      this.calcOrderNum()
    },
    //点击删除题目
    delQuestion(index) {
      this.paperQuestion.splice(index, 1)
      this.calcOrderNum()
    },
    //点击添加题目
    addQuestion(index) {
      this.current.currentIndex = index
      this.current.currentItemType = 1
      this.$refs.selectQuestionModal.open()
    },
    //点击添加大题标题
    addQuestionSection(index){
      this.current.currentItemType = 0
      // this.paperQuestion[index].questionSection = '大题标题'
      let t = this.paperQuestion[index]
      t.questionSection = '大题标题'
      Vue.set(this.paperQuestion, index, t)
    },
    //删除大标题
    delQuestionSection(index){
      let t = this.paperQuestion[index]
      t.questionSection = undefined
      Vue.set(this.paperQuestion, index, t)
    },
    //点击添加随机题目
    addQuestionRandom(index){
      this.current.currentIndex = index
      this.current.currentItemType = 2
      this.$refs.selectQuestionModal.open()
    },
    //确认添加随机题目
    ensureAddQuestionRandom(){
      this.parseQuestion({ 
        itemType:2,
        paperQuestionScore: this.current.currentRandomScore,
        randomCount: this.current.randomCount,
        randomSource: this.current.currentSelectQuestions
      }, this.current.currentIndex+1)
      this.current.currentItemType = 0
      this.current.currentSelectQuestions = null
      this.calcOrderNum()
    },
    //点击编辑题目
    editQuestion(q){
      this.$refs.questionModalForm.editById(q.questionId);
      this.$refs.questionModalForm.title = "编辑";
      this.$refs.questionModalForm.disableSubmit = false;
    },
    //编辑题目回调
    editQuestionOk(questionInfo){
      console.log(questionInfo);
      // 这里接收不到题目数据，需要从接口拉取
    },
    //选择题目回调
    handleSelectQuestionOK(rows, idstr){
      console.log(rows);
      console.log(idstr);
      if(rows.length == 0) return
      this.current.currentSelectQuestions = rows
      if(this.current.currentItemType == 1){
        //添加固定题目
        for(let i=0; i<rows.length; i++){
          let q = rows[i]
          q.itemType = 1
          q.questionId = q.id
          this.parseQuestion(q, this.current.currentIndex+i+1)
          this.calcOrderNum()
        }
      }else if(this.current.currentItemType == 2){
       //添加随机抽题
        this.current.currentRandomScore = rows[0].questionScore
      }
    },
    //点击从知识点抽题
    addQuestionFromKnowleage(index){
      this.current.currentIndex = index
      this.current.currentItemType = 3
      this.$refs.selectKnowleageQuestionModal.visible = true

    },
    //知识点抽题回调
    handleSelectQuestion(knowleages, randomCount){
      console.log(knowleages, randomCount);
      this.parseQuestion({
        itemType: 3,
        randomSource: knowleages,
        randomCount: randomCount
      }, this.current.currentIndex+1)
      this.calcOrderNum()
    },
    //刷新题目信息
    reflushQuestionInfo(questionInfo){

    }
    // getPaperInfo(id) {
    //   getAction('/teaching/teachingPaper/queryById', { id: id }).then((res) => {
    //     if (res.success) {
    //       this.paperInfo = res.result
    //       this.getPaperItem(id)
    //     } else {
    //       this.$message(res.message)
    //     }
    //   })
    // },
    // getPaperItem(id) {
    //   getAction('/teaching/teachingPaper/queryTeachingPaperItemByMainId', { id: id }).then((res) => {
    //     if (res.success) {
    //       this.paperItemList = res.result
    //     } else {
    //       this.$message(res.message)
    //     }
    //   })
    // },
  },
}
</script>

<style lang="less" scoped>
/deep/p {
  margin-bottom: 0.5em;
}
.ant-layout {
  width: 100%;
  background: transparent;
}
.ant-layout-header {
  background: #fff;
}
.ant-layout-sider {
  background: #fff;
  text-align: center;
}
.remain-time {
  color: red;
  font-size: 20px;
}
.question-index {
  text-align: left;
  .question-section {
    margin: 10px 0px;
  }
  .ant-tag {
    height: 30px;
    min-width: 30px;
    font-size: 14px;
    font-weight: 600;
    line-height: 28px;
    margin-top: 4px;
  }
}
.paper-content {
  .ant-card{
    color: black;
  }
  .ant-card-bordered{
    border: 1px solid #ff7736;
  }
  .item-operation{
      text-align: right;
  }
  .question-card {
    margin-bottom: 20px;
  }
  .question-section {
    border: 1px solid blue;
    padding: 10px;
    margin: 10px 0;
  }


}
</style>